import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// Components
import AfterRegistration from "../new_sign_up/after_sign_up/AfterRegistration";
import PaymentResult from "./PaymentResult";
import { PageContent } from "../new_sign_up/SignUpStyle";

const VnpayPaymentReturnUrl = (props: {
  setLoggedIn: (values: any) => void;
}) => {
  const { setLoggedIn } = props;
  const navigate = useNavigate();
  // for the stepper
  const [step, setStep] = useState(0);
  const [disableEffect, setDisableEffect] = useState(false);
  const [paymentResult, setPaymentResult] = useState<string>("");

  useEffect(() => {
    if (!disableEffect) {
      setLoggedIn(false);
    }
  }, [setLoggedIn, disableEffect]);

  const handleNext = () => {
    const fromRegister = localStorage.getItem("fromRegister");
    if (paymentResult) {
      if (fromRegister && paymentResult === "Success") {
        setStep(1);
        localStorage.removeItem("fromRegister");
      } else {
        setDisableEffect(true);
        setLoggedIn(true);
        navigate("/my-credits");
      }
    }
  };

  const renderSteps = () => {
    if (step === 0) {
      return (
        <PaymentResult
          handleNext={handleNext}
          setPaymentResult={setPaymentResult}
        />
      );
    }
    if (step === 1) {
      return <AfterRegistration setLoggedIn={setLoggedIn} />;
    }
    return null;
  };

  return (
    <PageContent style={{ width: "100vw" }}> {renderSteps()} </PageContent>
  );
};

export default VnpayPaymentReturnUrl;
